import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { LinkedList } from '../../../base/common/linkedList.js';
export var BracketSelectionRangeProvider = /*#__PURE__*/function () {
  function BracketSelectionRangeProvider() {
    _classCallCheck(this, BracketSelectionRangeProvider);
  }

  _createClass(BracketSelectionRangeProvider, [{
    key: "provideSelectionRanges",
    value: function provideSelectionRanges(model, positions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, _iterator, _step, _loop;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = [];
                _iterator = _createForOfIteratorHelper(positions);
                _context2.prev = 2;
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                  var position, bucket, ranges;
                  return _regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          position = _step.value;
                          bucket = [];
                          result.push(bucket);
                          ranges = new Map();
                          _context.next = 6;
                          return new Promise(function (resolve) {
                            return BracketSelectionRangeProvider._bracketsRightYield(resolve, 0, model, position, ranges);
                          });

                        case 6:
                          _context.next = 8;
                          return new Promise(function (resolve) {
                            return BracketSelectionRangeProvider._bracketsLeftYield(resolve, 0, model, position, ranges, bucket);
                          });

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 9;
                  break;
                }

                return _context2.delegateYield(_loop(), "t0", 7);

              case 7:
                _context2.next = 5;
                break;

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t1 = _context2["catch"](2);

                _iterator.e(_context2.t1);

              case 14:
                _context2.prev = 14;

                _iterator.f();

                return _context2.finish(14);

              case 17:
                return _context2.abrupt("return", result);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, null, [[2, 11, 14, 17]]);
      }));
    }
  }], [{
    key: "_bracketsRightYield",
    value: function _bracketsRightYield(resolve, round, model, pos, ranges) {
      var counts = new Map();
      var t1 = Date.now();

      while (true) {
        if (round >= BracketSelectionRangeProvider._maxRounds) {
          resolve();
          break;
        }

        if (!pos) {
          resolve();
          break;
        }

        var bracket = model.findNextBracket(pos);

        if (!bracket) {
          resolve();
          break;
        }

        var d = Date.now() - t1;

        if (d > BracketSelectionRangeProvider._maxDuration) {
          setTimeout(function () {
            return BracketSelectionRangeProvider._bracketsRightYield(resolve, round + 1, model, pos, ranges);
          });
          break;
        }

        var key = bracket.close[0];

        if (bracket.isOpen) {
          // wait for closing
          var val = counts.has(key) ? counts.get(key) : 0;
          counts.set(key, val + 1);
        } else {
          // process closing
          var _val = counts.has(key) ? counts.get(key) : 0;

          _val -= 1;
          counts.set(key, Math.max(0, _val));

          if (_val < 0) {
            var list = ranges.get(key);

            if (!list) {
              list = new LinkedList();
              ranges.set(key, list);
            }

            list.push(bracket.range);
          }
        }

        pos = bracket.range.getEndPosition();
      }
    }
  }, {
    key: "_bracketsLeftYield",
    value: function _bracketsLeftYield(resolve, round, model, pos, ranges, bucket) {
      var counts = new Map();
      var t1 = Date.now();

      while (true) {
        if (round >= BracketSelectionRangeProvider._maxRounds && ranges.size === 0) {
          resolve();
          break;
        }

        if (!pos) {
          resolve();
          break;
        }

        var bracket = model.findPrevBracket(pos);

        if (!bracket) {
          resolve();
          break;
        }

        var d = Date.now() - t1;

        if (d > BracketSelectionRangeProvider._maxDuration) {
          setTimeout(function () {
            return BracketSelectionRangeProvider._bracketsLeftYield(resolve, round + 1, model, pos, ranges, bucket);
          });
          break;
        }

        var key = bracket.close[0];

        if (!bracket.isOpen) {
          // wait for opening
          var val = counts.has(key) ? counts.get(key) : 0;
          counts.set(key, val + 1);
        } else {
          // opening
          var _val2 = counts.has(key) ? counts.get(key) : 0;

          _val2 -= 1;
          counts.set(key, Math.max(0, _val2));

          if (_val2 < 0) {
            var list = ranges.get(key);

            if (list) {
              var closing = list.shift();

              if (list.size === 0) {
                ranges.delete(key);
              }

              var innerBracket = Range.fromPositions(bracket.range.getEndPosition(), closing.getStartPosition());
              var outerBracket = Range.fromPositions(bracket.range.getStartPosition(), closing.getEndPosition());
              bucket.push({
                range: innerBracket
              });
              bucket.push({
                range: outerBracket
              });

              BracketSelectionRangeProvider._addBracketLeading(model, outerBracket, bucket);
            }
          }
        }

        pos = bracket.range.getStartPosition();
      }
    }
  }, {
    key: "_addBracketLeading",
    value: function _addBracketLeading(model, bracket, bucket) {
      if (bracket.startLineNumber === bracket.endLineNumber) {
        return;
      } // xxxxxxxx {
      //
      // }


      var startLine = bracket.startLineNumber;
      var column = model.getLineFirstNonWhitespaceColumn(startLine);

      if (column !== 0 && column !== bracket.startColumn) {
        bucket.push({
          range: Range.fromPositions(new Position(startLine, column), bracket.getEndPosition())
        });
        bucket.push({
          range: Range.fromPositions(new Position(startLine, 1), bracket.getEndPosition())
        });
      } // xxxxxxxx
      // {
      //
      // }


      var aboveLine = startLine - 1;

      if (aboveLine > 0) {
        var _column = model.getLineFirstNonWhitespaceColumn(aboveLine);

        if (_column === bracket.startColumn && _column !== model.getLineLastNonWhitespaceColumn(aboveLine)) {
          bucket.push({
            range: Range.fromPositions(new Position(aboveLine, _column), bracket.getEndPosition())
          });
          bucket.push({
            range: Range.fromPositions(new Position(aboveLine, 1), bracket.getEndPosition())
          });
        }
      }
    }
  }]);

  return BracketSelectionRangeProvider;
}();
BracketSelectionRangeProvider._maxDuration = 30;
BracketSelectionRangeProvider._maxRounds = 2;